import { SET_CSRF_TOKEN, SET_SETTINGS } from './types'

export const setCSRFToken = (token: string) => ({
  type: SET_CSRF_TOKEN,
  payload: token
})

export const setSettingsAction = (props: any) => ({
  type: SET_SETTINGS,
  payload: props
})
